import WorkOrdersPage from "@/pages/work-orders";
import type { RouteConfig } from "./types";

export const workOrderRoutes: RouteConfig[] = [
	{
		path: "/work-orders",
		element: <WorkOrdersPage />,
	},
	{
		path: "/work-orders/:AssetIdParam",
		element: <WorkOrdersPage />,
	},
];
